import React, {Component} from 'react';
import styled from 'react-emotion';

import SidebarHome from '../../components/SidebarHome';
import HomeEventsContent from '../../components/HomeEventsContent';
import HomeContactContent from '../../components/HomeContactContent';
import HomeMainContent from '../../components/HomeMainContent';
import HomeAboutContent from '../../components/HomeAboutContent';
import HomeEquipeContent from '../../components/HomeEquipeContent';
import {
	FlexRow, primaryWhite, H4, darkBeige,
} from '../../utils/content';

import {ReactComponent as logo} from '../logo.svg';
import backgroundImage from '../background.jpg';

const AppIcon = styled('div')`
	transition: all 0.3s ease;
	&:hover {
		filter: blur(3px);
	}
	cursor: pointer;
	@media screen and (min-width: 900px) {
		display: none;
	}
`;

const Logo = styled(logo)`
	width: 100px;
	height: auto;
	display: block;
	margin-left: auto;
	margin-right: auto;
	path {
		fill: white;
	}
	margin-left: auto;
	margin-right: auto;
	display: block;
`;

const Title = styled(H4)`
	font-variant: small-caps;
	letter-spacing: 8px;
	color: ${props => (props.isActive && !props.alwaysWhite ? darkBeige : primaryWhite)};
	font-family: 'BWHaas', sans-serif;
	cursor: pointer;
	transition: color 0.3s ease;
	font-size: 110%;
	text-align: center;
	&:hover {
		color: ${props => (props.alwaysWhite ? primaryWhite : darkBeige)};
	}
`;

const HomeMain = styled('div')`
position: relative;
width: calc(100vw - 80px);
height: calc(100vh - 40px);
background-size: cover;
padding: 20px 40px;
@media screen and (max-width: 900px) {
	padding: 20px 10px;
	width: calc(100vw - 20px);
	height: 100%;
}
`;

const MainContentWrapper = styled('div')`
	flex: 2;
	padding-left: 40px;
	padding-right: 40px;
	@media screen and (max-width: 900px) {
		padding-left: 0px;
		padding-right: 0px;
	}
`;

const MainContent = styled('div')`
	margin-left: auto;
	margin-right: auto;
	max-width: 800px;
	@media screen and (max-width: 900px) {
		margin-top: 0px;
	}
`;

const HomeRow = styled(FlexRow)`
	@media screen and (max-width: 900px) {
		flex-direction: column-reverse;
	}
`;

class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeMode: 'main',
		};
	}

	setActiveMode = (mode) => {
		this.setState({activeMode: mode});
	};

	render() {
		const {activeMode} = this.state;

		return (
			<HomeMain style={{'backgroundImage': this.state.activeMode === 'main'? `url(${backgroundImage})` : ''}}>
				<AppIcon
					onClick={() => {
						this.setActiveMode('main');
					}}
				>
					<Logo />
					<Title alwaysWhite={true}>le sycomore</Title>
				</AppIcon>
				<HomeRow>
					<SidebarHome
						setActiveMode={this.setActiveMode}
						activeMode={activeMode}
					/>
					<MainContentWrapper>
						<MainContent>
							{(() => {
								switch (activeMode) {
								case 'about':
									return <HomeAboutContent />;
								case 'equipe':
									return <HomeEquipeContent />;
								case 'events':
									return <HomeEventsContent />;
								case 'contact':
									return <HomeContactContent />;
								default:
									return <HomeMainContent />;
								}
							})()}
						</MainContent>
					</MainContentWrapper>
				</HomeRow>
			</HomeMain>
		);
	}
}

export default Home;
